import { render, staticRenderFns } from "./Owners.vue?vue&type=template&id=0123912c&scoped=true&lang=pug"
import script from "./Owners.vue?vue&type=script&lang=js"
export * from "./Owners.vue?vue&type=script&lang=js"
import style0 from "./Owners.vue?vue&type=style&index=0&id=0123912c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0123912c",
  null
  
)

export default component.exports